import type { SVGProps } from 'react';
export const DeselectAll = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M15.83 3H4.17A1.17 1.17 0 0 0 3 4.17v11.66A1.17 1.17 0 0 0 4.17 17h11.66A1.17 1.17 0 0 0 17 15.83V4.17A1.17 1.17 0 0 0 15.83 3m0 12.83H4.17V4.17h11.66zm-3.08-7.75L10.82 10l1.93 1.92a.59.59 0 0 1-.42 1 .6.6 0 0 1-.4-.17L10 10.82l-1.92 1.93a.58.58 0 0 1-.83-.83L9.18 10 7.25 8.08a.58.58 0 0 1 .83-.83L10 9.18l1.92-1.93a.58.58 0 0 1 .83.83" />
  </svg>
);
